import React from 'react';
// import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import PropTypes from "prop-types";

import FeaturesFiltersBody from "./FeaturesFiltersBody";
import {toggleFeaturesFiltersVisible} from "./FeaturesFiltersActions";
import {filterGroupByID} from "../../Filters/FiltersReducer";

class FeaturesFilters extends React.Component {

  static propTypes = {
    // activeFeaturesGroupName: PropTypes.string.isRequired
  };

  handleFiltersByClick = () => {
    document.addEventListener('click', this.handleWrapperBlur);
    this.props.toggleFeaturesFiltersVisible(true);
    if (this.props.onOpened) {
      this.props.onOpened();
    }
  };

  handleWrapperBlur = (e) => {
    if (!e.target.closest('[class*="filters"]') && !e.target.closest('[class*="ui-svg-checkbox"]') && !e.target.closest('[class*="employees-checkbox-circle"]')) {
      this.props.toggleFeaturesFiltersVisible(false);
      document.removeEventListener('click', this.handleWrapperBlur);
    }
  };

  getButtonIcons = () => {
    // const filterGroup = this.props.allFilterGroups.find(group => group.name === "Materials");
    if (!this.props.selectedFilters.length) {
      return <span className="filters-button__icon filters-button__icon--filters"/>
    }
    const selectedFilterGroupIds = [...new Set(this.props.selectedFilters.map(selectedFilter => selectedFilter.filterGroupId))];
    // ...new Set removes duplicates, if it appears broken anywhere in old browsers - use plain old logic or lodash
    return selectedFilterGroupIds.map((selectedFilterGroupId, selectedFilterGroupIdIndex) => {
      const filterGroup = this.props.allFilterGroups.find(fGroup => fGroup.id === selectedFilterGroupId);
      const name = filterGroup && filterGroup.name
        ? filterGroup.name.toLowerCase().replace(/ /g, "-")
        : "";
      return (
        <span key={selectedFilterGroupIdIndex}
              className={"filters-button__icon filters-button__icon--general filters-button__icon--" + name}/>
      )
    });
  };

  render() {
    return (
      <div className="filters">
        <button className="filters-button" onClick={this.handleFiltersByClick}>
          <span className="filters-button__text">Filter By</span>
          {this.getButtonIcons()}
        </button>
        <div className={"filters-container" + (this.props.featuresFiltersVisible ? " filters-container--visible" : "")}>
          {this.props.featuresFiltersVisible ? <FeaturesFiltersBody featureGroupName={this.props.featureGroupName}
                                                                    forFabricatorId={this.props.forFabricatorId}
                                                                    featuresSetupPage={this.props.featuresSetupPage}/> : null}
        </div>
      </div>
    )
  }
}

FeaturesFilters.propTypes = {
  featuresSetupPage: PropTypes.bool,
  featureGroupName: PropTypes.string,
  onOpened: PropTypes.func,
  forFabricatorId: PropTypes.number,
}

const mapStateToProps = (store) => {
  return {
    featuresFiltersVisible: store.featuresFiltersState.featuresFiltersVisible,
    selectedFilters: store.featuresFiltersState.selectedFilters,
    allFilterGroups: store.featuresFiltersState.allFilterGroups
  };
};

export default connect(mapStateToProps, {
  toggleFeaturesFiltersVisible
})(FeaturesFilters);
